const ZONE_SUFFIX = /(Z|[+-]\d{2}:?\d{2})$/i;

const parseUtc = (value) => {
    if (value === null || value === undefined || value === "") return null;
    if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
    const text = String(value).trim().replace(" ", "T");
    const date = new Date(ZONE_SUFFIX.test(text) ? text : `${text}Z`);
    return isNaN(date.getTime()) ? null : date;
};

export const formatUtc = (value, fallback = "N/A") => {
    const date = parseUtc(value);
    if (!date) return fallback;
    return `${date.toISOString().slice(0, 16).replace("T", " ")} UTC`;
};

export const toUtcInput = (value) => {
    const date = parseUtc(value);
    return date ? date.toISOString().slice(0, 16) : "";
};

export const fromUtcInput = (text, empty = null) => {
    const date = parseUtc(text);
    return date ? date.toISOString() : empty;
};
